/**
 * Kalkulator prawidłowej wagi: widok.
 *
 * Wszystkie obliczenia robi ideal-weight-calculator-logic.js (window.DnnzIdealWeightLogic).
 * Ten plik niczego nie dorenderowuje: tabelka przykładów, panel wyniku,
 * blokady i teksty stoją w źródle HTML. Tutaj dzieje się tylko
 * odczyt pól, przełączanie stanów, wstawianie liczb w zdania z atrybutów
 * data-text-* i przyklejany pasek nawigacji.
 *
 * Konfigurację (liczby) skrypt czyta z atrybutu data-config sekcji, który
 * szablon wypełnia z inc/data/ideal-weight.php. Stan nie jest nigdzie zapisywany.
 *
 * Vanilla JS, bez jQuery.
 */
(function () {
	'use strict';

	function toggle(element, visible) {
		if (element) {
			element.hidden = !visible;
		}
	}

	function fill(template, values) {
		return String(template || '').replace(/\{([a-z0-9]+)\}/g, function (match, key) {
			return Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match;
		});
	}

	function fillPercent(value, min, max) {
		if (!(max > min)) {
			return 0;
		}
		return Math.min(100, Math.max(0, ((value - min) / (max - min)) * 100));
	}

	function initCalculator(root, L) {
		var cfg;
		try {
			cfg = JSON.parse(root.getAttribute('data-config'));
		} catch (e) {
			return;
		}

		var q = function (selector) {
			return root.querySelector(selector);
		};

		var KEYS = ['age', 'height', 'weight'];
		var UNITS = { age: 'lat', height: 'cm', weight: 'kg' };
		var numbers = {};
		var ranges = {};
		var fills = {};
		var errors = {};
		KEYS.forEach(function (key) {
			numbers[key] = q('[data-role="' + key + '-number"]');
			ranges[key] = q('[data-role="' + key + '-range"]');
			fills[key] = q('[data-role="' + key + '-fill"]');
			errors[key] = q('[data-role="' + key + '-error"]');
		});

		var states = {};
		['empty', 'value', 'minor', 'impossible'].forEach(function (name) {
			states[name] = q('[data-state="' + name + '"]');
		});
		var valueState = states.value;
		var lowEl = q('[data-role="low"]');
		var highEl = q('[data-role="high"]');
		var lineEl = q('[data-role="line"]');
		var scale = q('[data-role="scale"]');
		var scaleBar = q('[data-role="scale-bar"]');
		var marker = q('[data-role="marker"]');
		var compare = q('[data-role="compare"]');
		var diffLabel = q('[data-role="diff-label"]');
		var diffValue = q('[data-role="diff-value"]');
		var diffEl = q('[data-role="diff"]');
		var noteEl = q('[data-role="note"]');
		var liveEl = q('[data-role="live"]');

		if (!numbers.height || !states.empty || !valueState) {
			return;
		}

		// Odświeżenie strony = stan wyjściowy: przeglądarki potrafią przywrócić
		// wpisane wartości, więc na starcie jawnie wracamy do wartości z HTML.
		KEYS.forEach(function (key) {
			if (numbers[key]) {
				numbers[key].value = numbers[key].defaultValue;
			}
		});

		function text(name) {
			return valueState.getAttribute('data-text-' + name) || '';
		}

		/**
		 * Jedna linia pod liczbą: wzrost i wiek w pełnych latach
		 * („Dla wzrostu 170 cm i wieku 45 lat.”).
		 */
		function rangeLine(state) {
			return fill(text('line'), {
				wzrost: L.formatNumber(state.height),
				wiek: state.years
			});
		}

		/**
		 * Skala masy: poniżej, zakres, powyżej. Oś sięga o szerokość zakresu
		 * w obie strony, masa spoza osi stoi na jej końcu.
		 */
		function updateScale(state) {
			var show = state.weight !== null;
			toggle(scale, show);
			if (!show) {
				return;
			}
			var span = state.high - state.low;
			var min = state.low - span;
			var max = state.high + span;
			var at = function (v) {
				return fillPercent(v, min, max);
			};
			var widths = { low: at(state.low), normal: at(state.high) - at(state.low), high: 100 - at(state.high) };
			Object.keys(widths).forEach(function (seg) {
				var el = scale.querySelector('[data-seg="' + seg + '"]');
				if (el) {
					el.style.width = widths[seg] + '%';
				}
			});
			['low', 'high'].forEach(function (tick) {
				var el = scale.querySelector('[data-tick="' + tick + '"]');
				if (el) {
					el.style.left = at(state[tick]) + '%';
					el.textContent = String(state[tick]);
				}
			});
			if (marker) {
				marker.style.left = at(state.weight) + '%';
			}
			if (scaleBar) {
				scaleBar.setAttribute('aria-label', fill(text('scale'), { low: state.low, high: state.high, masa: L.formatNumber(state.weight) }));
			}
		}

		function updateCompare(state) {
			var show = state.weight !== null;
			toggle(compare, show);
			// Najwyżej jedna linia pod kafelkiem (D3, D8), także bez podanej masy od 65 lat.
			toggle(noteEl, state.note !== null);
			if (state.note !== null) {
				noteEl.textContent = fill(text('note-' + state.note), { prog: state.floor });
			}
			if (!show) {
				return;
			}
			// „Powyżej zakresu o X kg”, „Poniżej zakresu o X kg” albo samo „W zakresie” (D8).
			diffLabel.textContent = valueState.getAttribute('data-label-' + state.status) || '';
			toggle(diffValue, state.diff !== null);
			if (state.diff !== null) {
				diffEl.textContent = L.formatNumber(state.diff);
			}
		}

		function render() {
			var input = {};
			KEYS.forEach(function (key) {
				input[key] = numbers[key] ? numbers[key].value : '';
			});
			var state = L.evaluate(input, cfg);

			// Komunikaty przy polach.
			KEYS.forEach(function (key) {
				toggle(errors[key], state.fields[key].invalid);
			});

			// Suwak i pole liczbowe to jedna wartość w dwóch kontrolkach.
			KEYS.forEach(function (key) {
				var range = ranges[key];
				var field = state.fields[key];
				var limits = cfg.sliders[key];
				if (!range) {
					return;
				}
				range.classList.toggle('is-empty', field.value === null);
				if (field.value !== null) {
					range.value = Math.min(limits.max, Math.max(limits.min, Math.round(field.value)));
					range.setAttribute('aria-valuetext', numbers[key].value.trim() + ' ' + UNITS[key]);
				} else {
					range.value = limits.min;
					range.setAttribute('aria-valuetext', 'nie podano');
				}
				if (fills[key]) {
					fills[key].style.width = field.value === null ? '0%' : fillPercent(field.value, limits.min, limits.max) + '%';
				}
			});

			var shown = state.blocked === 'minor' ? 'minor'
				: state.impossible ? 'impossible'
				: state.hasResult ? 'value' : 'empty';
			Object.keys(states).forEach(function (name) {
				toggle(states[name], name === shown);
			});

			var line = '';
			if (state.hasResult) {
				lowEl.textContent = String(state.low);
				highEl.textContent = String(state.high);
				line = rangeLine(state);
				lineEl.textContent = line;
				updateScale(state);
				updateCompare(state);
			}

			if (liveEl) {
				liveEl.textContent = state.hasResult ? fill(text('live'), { low: state.low, high: state.high }) + ' ' + line : '';
			}
		}

		KEYS.forEach(function (key) {
			if (numbers[key]) {
				numbers[key].addEventListener('input', render);
			}
			if (ranges[key]) {
				ranges[key].addEventListener('input', function () {
					numbers[key].value = ranges[key].value;
					render();
				});
			}
		});
		render();
	}

	/**
	 * Nawigacja kotwicowa dokleja się pod header motywu i jedzie z czytelnikiem
	 * do końca strony (jak w spalaniu i nawodnieniu: pozycję przełącza skrypt,
	 * bo position: sticky kończy się razem z sekcją bloku).
	 */
	function initStickyNav(root) {
		var nav = root.querySelector('[data-role="nav"]');
		if (!nav) {
			return;
		}

		var header = document.querySelector('.site-header');
		var spacer = document.createElement('div');
		spacer.className = 'ideal-weight-calculator__nav-spacer';
		spacer.hidden = true;
		nav.parentNode.insertBefore(spacer, nav);

		var isFixed = false;
		var ticking = false;
		var list = nav.querySelector('ul');
		var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
		var targets = links.map(function (link) {
			var id = link.getAttribute('href').slice(1);
			return id ? document.getElementById(id) : null;
		});
		var activeIndex = -1;

		function headerOffset() {
			if (!header) {
				return 0;
			}
			var position = window.getComputedStyle(header).position;
			if (position !== 'sticky' && position !== 'fixed') {
				return 0;
			}
			var rect = header.getBoundingClientRect();
			return rect.top <= 0 ? Math.max(0, Math.round(rect.bottom)) : 0;
		}

		function keepVisible(link) {
			if (!list || list.scrollWidth <= list.clientWidth) {
				return;
			}
			var item = link.parentNode.getBoundingClientRect();
			var box = list.getBoundingClientRect();
			var margin = 16;
			if (item.left < box.left + margin) {
				list.scrollLeft += item.left - box.left - margin;
			} else if (item.right > box.right - margin) {
				list.scrollLeft += item.right - box.right + margin;
			}
		}

		function updateActive(offset) {
			if (!links.length) {
				return;
			}
			var line = offset + (isFixed ? nav.getBoundingClientRect().height : 0) + 16;
			var current = -1;
			targets.forEach(function (target, index) {
				if (target && target.getBoundingClientRect().top <= line) {
					current = index;
				}
			});
			// Sekcja, która cała przewinęła się nad linię odczytu, oddaje
			// aktywność następnej (rozszerzenie skryptu spalania, jak w nawodnieniu).
			if (current !== -1 && targets[current].getBoundingClientRect().bottom < line) {
				for (var j = current + 1; j < targets.length; j++) {
					if (targets[j]) {
						current = j;
						break;
					}
				}
			}
			var atBottom = window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 2;
			if (atBottom) {
				for (var i = targets.length - 1; i >= 0; i--) {
					if (targets[i]) {
						current = i;
						break;
					}
				}
			}
			if (current === activeIndex) {
				return;
			}
			if (links[activeIndex]) {
				links[activeIndex].classList.remove('is-active');
				links[activeIndex].removeAttribute('aria-current');
			}
			activeIndex = current;
			if (links[activeIndex]) {
				links[activeIndex].classList.add('is-active');
				links[activeIndex].setAttribute('aria-current', 'true');
				keepVisible(links[activeIndex]);
			}
		}

		function update() {
			ticking = false;
			var offset = headerOffset();
			root.style.setProperty('--iw-sticky-top', offset + 'px');
			var top = (isFixed ? spacer : nav).getBoundingClientRect().top;
			if (!isFixed && top <= offset) {
				var margin = parseFloat(window.getComputedStyle(nav).marginBottom) || 0;
				spacer.style.height = nav.getBoundingClientRect().height + margin + 'px';
				spacer.hidden = false;
				nav.classList.add('is-fixed');
				isFixed = true;
			} else if (isFixed && top > offset) {
				nav.classList.remove('is-fixed');
				spacer.hidden = true;
				isFixed = false;
			}
			updateActive(offset);
		}

		function onScroll() {
			if (!ticking) {
				ticking = true;
				window.requestAnimationFrame(update);
			}
		}

		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onScroll);
		window.addEventListener('load', onScroll);
		update();
	}

	function init() {
		var L = window.DnnzIdealWeightLogic;
		var blocks = Array.prototype.slice.call(document.querySelectorAll('[data-ideal-weight]'));
		blocks.forEach(function (root) {
			if (L) {
				initCalculator(root, L);
			}
			initStickyNav(root);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
